import { render, staticRenderFns } from "./regionCompare.vue?vue&type=template&id=f87f0306"
import script from "./regionCompare.vue?vue&type=script&lang=js"
export * from "./regionCompare.vue?vue&type=script&lang=js"
import style0 from "./regionCompare.vue?vue&type=style&index=0&id=f87f0306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports